import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../providers/language.provider';
import ChooseLanguage from '../pages/choose-language.page';
import config from '../config';

const ChooseLanguageWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { switchLanguage } = useLanguage();

  useEffect(() => {
    // Check if the ID is in the whitelist for English default
    if (id && config.language.english_locked_ids.includes(id)) {
      console.log(`Setting English as default for whitelisted ID: ${id}`);
      switchLanguage("en");
    }
  }, [id, switchLanguage]);

  return <ChooseLanguage />;
};

export default ChooseLanguageWrapper;
